import { Field } from 'formik';
import { Shelf, Icon, Tooltip } from '@chaser/components';
import { elementType, func, node, oneOfType, string } from 'prop-types';
import React from 'react';
import style from './fieldWithError.module.scss';
import { Position } from '../Positioner';

const getNestedError = (errors, touched, name) => {
  const path = name.split('.');
  let error = errors;
  let touch = touched;

  for (let i = 0; i < path.length; i++) {
    if (error) error = error[path[i]];
    if (touch) touch = touch[path[i]];
  }

  return touch && error ? error : null;
};

const FieldWithError = ({
  name,
  children = undefined,
  as: Comp = undefined,
  type = undefined,
  validate = undefined,
  ...rest
}) => (
  <Field name={name} type={type} validate={validate}>
    {({ field, form }) => {
      const error = getNestedError(form.errors, form.touched, name);
      return Comp ? (
        <Shelf gap="xsmall" flexWrap="nowrap">
          <Comp {...field} error={error} {...rest} type={type} className={style.caretColor}>
            {children}
          </Comp>
          {error && (
            <Tooltip as="div" disable={!error} content={error} position={Position.RIGHT}>
              <Icon name="info" color="Red" />
            </Tooltip>
          )}
        </Shelf>
      ) : (
        children({ field, error, form })
      );
    }}
  </Field>
);

FieldWithError.propTypes = {
  name: string.isRequired,
  children: oneOfType([node, func]),
  type: string,
  as: elementType,
  validate: func,
};

export default FieldWithError;
